import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import { BASE_URL } from '../env'
const lang = localStorage.getItem("language") || "FR"
const dfltCountry = "BE"
const countryService = `${BASE_URL}/onboarding-entrepreneur-front/v1/countries/`

async function fetchCountry() {
        const res = await (await fetch(`${countryService}${lang}`)).json()
        const reRes = res.map(ctr => ({
            name: ctr.title,
            callingCode: ctr.phoneCode,
            code: ctr.iso2,
            isDefault: ctr.isDefault,
            priority: ctr.priority,
            translation: {
                de: ctr.title,
                fr: ctr.title,
                nl: ctr.title
            }
        }))

        return ({
            fullCountryList: reRes,
            defaultCountry: reRes.find(ctr => (ctr.code === dfltCountry)),
            priorityCountry: reRes.filter(ctr => (ctr.priority !== 0)) 
        })
}
    
const initialState = {
    fullCountryList: [],
    defalutCountry: {},
    priorityCountry: []
};

export const CountryContext = React.createContext(initialState);

export function CountryContextProvider(props) {
    const [countryList, setCountryList] = useState()

    useEffect(() => {
        fetchCountry().then(res => setCountryList(res))
    }, [])

    return (
            <CountryContext.Provider value={countryList}>
                {props.children}
            </CountryContext.Provider>
        )
}

CountryContextProvider.propTypes = {
    children: PropTypes.node
};
